
app.controller('calendarCtrl', ['$rootScope', '$scope', '$http', 'statisticsService', 'Notification', 'NetworkService', 'MainService', 'ColorService', '$timeout', function ($rootScope, $scope, $http, statisticsService, Notification, NetworkService, MainService, ColorService, $timeout) {

        window.maInfoBoxOpen = false;
        $scope.people = [];
        $scope.eventId = EventId;
        $scope.hourHeight = 35;
        $scope.paginatorPage = 0;
        MainService.setEventData({event_id: $scope.eventId})
        $scope.data = {}
        fields = {}
        fields["command"] = "getCalendar"
        fields["event_id"] = EventId

        actualPos = -1
        actualTime = -1

        $scope.startDate = -1
        $scope.schichtId = -1;
        $scope.posId = -1;
        $scope.CalenderAgent = -1
        $scope.maId = "<?php echo(getUsername()); ?>"
        $scope.showMaximize = true;
        $scope.showViewThree = false;

        $(document).on("mousemove", function (e) {
            var left = e.pageX - 20;
            var top = e.pageY - 25
            $("#mouseCircleCanvas").css("left", left + "px")
            $("#mouseCircleCanvas").css("top", top + "px")
        })

        NetworkService.getHighestPermission(function (data) {
            $scope.secLevel = data.level
        })

        $scope.endMouseCircle = function (e)
        {
            var c = $(e.currentTarget).attr("class")
            console.log(e)
            if (c.indexOf("profilePicInput") == -1)
            {
                /* $("#mouseCircleCanvas").attr("data-percent", "0")
                 $("#mouseCircleCanvas").css("display", "none")*/
            }

        }

        $scope.getFreePositionsInSchicht = function(schichtObj)
        {
            return schichtObj.menge - Object.keys(schichtObj.mitarbeiter).length
        }
        $scope.generateFullStatus = function (schichtObj)
        {

            var free = $scope.getFreePositionsInSchicht(schichtObj)
            var all = schichtObj.menge
            return free + " von Plätzen " + all + " frei"
        }

        $scope.getPartner = function (schichtObj, i)
        {
            var mitarbeiter = schichtObj["mitarbeiter"][i];
            var partnerName = undefined;
            if (mitarbeiter != undefined)
            {
                var partnerName = mitarbeiter.partner;
                if (partnerName == null)
                {
                    partnerName = mitarbeiter.gesucht;
                }
            }
            return partnerName;
        }
        $scope.hasPartner = function (schichtObj, i)
        {
            var mitarbeiter = schichtObj["mitarbeiter"][i];
            var ret = false;
            if (mitarbeiter != undefined)
            {
                if (mitarbeiter.paarStatus != null)
                {
                    ret = true;
                }
            }
            return ret;
        }

        $scope.startMouseCircle = function (e, schicht, email)
        {
            /*
             if (isNaN(email) && email.indexOf("@") != -1 && !window.maInfoBoxOpen)
             {
             var el = $(e.currentTarget)
             $(el).css("position", "relative")
             $(el).append("<div id='helperInput' onmouseleave='endMouseCircle()'></div>")
             window.acutalCircle = {running: true}
             window.acutalCircle.id = setTimeout(function () {
             $("#mouseCircleCanvas").attr("data-percent", "100")
             $("#mouseCircleCanvas").css("display", "block")
             }, 700)

             $timeout(function () {
             if (window.acutalCircle.running)
             {

             window.acutalCircle.running = false;
             endMouseCircle()
             $rootScope.$emit("renderMaInfoBox", email)

             var offset = $(el).offset()
             var width = parseInt($(".smallInput").css("width").replace("px", ""))
             offset.left += width + 10
             offset.top -= 10
             window.maInfoBoxOpen = true;
             $("#maInfoBox .card").css("left", offset.left + "px")
             $("#maInfoBox .card").css("top", offset.top + "px")
             $("#maInfoBox").css("display", "block")
             $("#maInfoBox").on("click", function () {
             $("#maInfoBox").css("display", "none")
             })
             $("#maInfoBox .card").on("click", function (e) {
             e.stopPropagation()
             })

             } else
             {

             }
             }, 1500)
             }

             */
        }
        $scope.addUserIntoEa = function (ea)
        {
            $scope.eingesetztAlsModel = ea.text;
        }
        NetworkService.getEingesetztAls(function (data) {
            $scope.eingesetztAls = data.data
        })
        $rootScope.$on("changeView", function () {
            $scope.changeView()
        })
        $scope.changeView = function ()
        {
            $scope.showViewThree = !$scope.showViewThree;
        }
        $scope.isShiftEmpty = function (schicht)
        {

            var ret = false
            if ($scope.showViewThree)
            {
                if (schicht.menge == 0 || schicht.menge == null)
                {
                    ret = true;
                }
            }
            return ret;
        }

        $scope.startMover = function (pos, posObj, schicht)
        {
            ret = 0


            start = posObj.start
            var t = start.split(/[- :]/);
            var d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
            //hours = d / 1000 / 60 / 60;


            var t2 = $scope.startDate.split(/[- :]/);
            var d2 = new Date(t2[0], t2[1] - 1, t2[2], t2[3], t2[4], t2[5]);

            posi = d - d2
            posi = posi / 1000 / 60 / 60

            actualPos = pos
            posi *= $scope.hourHeight
            return posi
        }


        $scope.maximizeShift = function (event)
        {
            $scope.showMaximize = false;
            var el = $(event.target).parent().parent().parent()
            $(el).css("height", "auto")
        }

        $scope.minimizeShift = function (event)
        {
            $scope.showMaximize = true;
            var el = $(event.target).parent().parent().parent()
            $(el).css("height", "150px")
        }

        $scope.getMaEmail = function (data, email)
        {

            ret = "";
            data = data["mitarbeiter"][email]
            if (data != undefined)
            {
                ret = data.vorname + " " + data.nachname
            }

            return ret;
        }

        $scope.hideProfilePic = function (data, i)
        {
            ret = true;
            keys = Object.keys(data["mitarbeiter"])[i]
            data = data["mitarbeiter"][keys]
            if (data != undefined)
            {
                ret = false
            }

            return ret;
        }

        $scope.getMaName = function (data, i)
        {
            ret = "";
            keys = Object.keys(data["mitarbeiter"])[i]
            data = data["mitarbeiter"][keys]
            if (data != undefined)
            {
                ret = data.email
            }

            return ret;
        }

        $scope.getIfUsed = function (data, i)
        {

            var ret = "";
            var keys = Object.keys(data["mitarbeiter"])[i]
            data = data["mitarbeiter"][keys]
            if (data != undefined)
            {
                ret = " used"
            }

            return ret;
        }
        $scope.generateFreiText = function (nochFrei)
        {
            var ret = "-1"
            if (nochFrei == 0)
            {
                ret = "Voll"
            } else
            {
                ret = "Frei"
            }
            return ret
        }

        $scope.getAddPosToShiftControlls = function (data)
        {
            ret = true;
            if (data.menge == null || data.menge == 0)
            {
                ret = false;
            }

            return ret
        }

        $scope.openEditPairDialog = function (schichtObj, i)
        {
            var mitarbeiter = schichtObj["mitarbeiter"][i];
            mitarbeiter.schicht_id = schichtObj.schicht_id
            mitarbeiter.position_id = schichtObj.posId;
            MainService.setDialogData("dialog_editPairCtrl", mitarbeiter)
            $rootScope.$emit("render_dialog_editPairCtrl")
            $("#dialog_editPair").modal("open");
        }
        $scope.getAcceptControlls = function (schichtObj, i)
        {

            var mitarbeiter = schichtObj["mitarbeiter"][i];
            var ret = true;
            if (mitarbeiter != undefined)
            {
                if (mitarbeiter.approved == 0)
                {
                    ret = false;
                }
            }
            /*if (data != undefined)
             {
             if (data.approved == 1)
             {
             ret = false
             }
             }*/

            return ret;
        }

        $scope.getRemoveControlls = function (data, email)
        {
            ret = true;
            data = data["mitarbeiter"][email]
            if (data != undefined)
            {
                if (data.approved == 1)
                {
                    ret = false
                }

            }

            return ret;
        }

        $scope.getWaitControlls = function (data, email)
        {
            ret = true;
            data = data["mitarbeiter"][email]
            if (data != undefined)
            {
                if (data.approved == 2)
                {
                    ret = false
                }

            }

            return ret;
        }

        $scope.generateApprovedText = function (data)
        {
            text = ""

            if (data.approved == 1)
            {
                text = "Sie sind Eingetragen"
            } else if (data.approved == 0)
            {
                text = "Muss noch vom Admin freigegeben werden"
            }

            return text
        }

        $scope.registerForSchichtButton = function ()
        {

            schichtId = $scope.schichtId;
            posId = $scope.posId;

            fields = {}
            fields["command"] = "addUserToSchicht"
            fields["schichtId"] = schichtId
            fields["posId"] = posId

            var req = {
                method: 'POST',
                url: "Api/hosiapi.php",
                data: $.param(fields),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            }
            $http(req).then(function (data) {
                fields = {}
                fields["command"] = "getCalendar"
                fields["event_id"] = EventId
                var req = {
                    method: 'POST',
                    url: "Api/hosiapi.php",
                    data: $.param(fields),
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                }
                $http(req).then(function (data) {

                    $scope.renderCalendar(data);
                }, "json");
            }, "json");


            $scope.hideOverlay()
        }

        $scope.checkIfOverlap = function (el)
        {
            ret = ""
            console.log(el)
            if (el.email == null)
            {
                lapsOver = $scope.CalenderAgent.doesOverlapp(el)
                if (lapsOver)
                {
                    ret = "Gleichzeitig mit andere Schicht"

                } else
                {
                    ret = ""
                }
            }
            return ret

        }


        $scope.overLapCss = function (el)
        {
            ret = ""
            if (el.arbeite_mit == null)
            {
                lapsOver = $scope.CalenderAgent.doesOverlapp(el)
                if (lapsOver)
                {
                    ret = "background-color: #95a5a6;cursor:default; "

                } else
                {
                }
            }
            return ret

        }

        $scope.hideOverlay = function ()
        {
            $("#registerForSchichtWindow").fadeOut();
            $("#overlayWindow").fadeOut();
        }

        $scope.openEditSchichtDialog = function (schichtObj)
        {

            MainService.setDialogData('dialog_editSchichtCtrl', schichtObj)
            $("#dialog_editSchicht").modal("open")
            $rootScope.$emit("render_dialog_editSchichtCtrl")
        }

        $rootScope.$on("repaint", function () {
            $scope.paintCalendar();
        })
        $scope.openEditPositionDialog = function (posObj)
        {
            MainService.setDialogData('dialog_editPositionCtrl', posObj)
            $("#dialog_editPosition").modal("open")
            $rootScope.$emit("render_dialog_editPositionCtrl")
        }

        $scope.renderDate = function (d)
        {
            var t = d.split(/[- :]/);

            var date = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
            var minutes = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
            var hours = (date.getHours() < 10 ? '0' : '') + date.getHours()
            return hours + ":" + minutes
        }

        $scope.renderClass = function (data)
        {
            className = "black"
            userWorking = data["mitarbeiter"][$scope.maId];
            lapsOver = $scope.CalenderAgent.doesOverlapp(data);
            // Wenn er Mitarbeitet
            if (data.menge == null)
            {
                className = "editmode "
            } else // Wenn noch plaetze frei sind
            {
                className = "editmode "
            }
            return className
        }

        /*
         * Obsolet
         */
        $scope.getSize = function (von, bis)
        {

            var t = von.split(/[- :]/);
            var d1 = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);

            var t2 = bis.split(/[- :]/);
            var d2 = new Date(t2[0], t2[1] - 1, t2[2], t2[3], t2[4], t2[5]);
            var timeDiff = Math.abs(d2 - d1);
            difHours = timeDiff / 1000 / 60 / 60
            //return d.getHours()+":"+d.getMinutes()
            size = difHours * $scope.hourHeight
            if (size < 52)
            {
                size = 59;
            }
            return size;
        }

        var req = {
            method: 'POST',
            url: "Api/hosiapi.php",
            data: $.param(fields),
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        }


        $scope.openAcceptUserDialog = function (email, schichtObj, posObj)
        {
            data = {email: email,
                schicht_id: schichtObj.schicht_id,
                position_id: posObj.position_id}
            MainService.setDialogData("dialog_acceptUserSchichtCtrl", data)
            $("#dialog_acceptUserSchicht").modal("open")
        }

        $scope.acceptUser = function ()
        {
            email = $scope.dialog_acceptUser_email
            schichtObj = $scope.dialog_acceptUser_schichtObj
            posObj = $scope.dialog_acceptUser_posObj
            eingesetzAlsText = $("#eingesetzAlsText").val()
            fields = {}
            fields["command"] = "acceptUserSchicht"
            fields["schicht_id"] = schichtObj.schicht_id
            fields["position_id"] = posObj.position_id
            fields["eingesetzt_als"] = eingesetzAlsText
            fields["email"] = email
            var req = {
                method: 'POST',
                url: "Api/hosiapi.php",
                data: $.param(fields),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            }

            $http(req).then(function (data) {

            }, "json");

        }

        $scope.removeUser = function (email, schichtObj, posObj)
        {
            //$("#dialog_declineUserMemo").modal("open")
            NetworkService.removeUserFromSchicht(schichtObj.schicht_id, posObj.position_id, email, function (data) {
                $rootScope.$emit("repaint");
            })
            /*data = {email: email,
             position_id: posObj.position_id,
             schicht_id: schichtObj.schicht_id}*/
            //MainService.setDialogData("dialog_declineUserMemo", data)
            /*fields = {}
             fields["schicht_id"] = schichtObj.schicht_id
             fields["position_id"] = posObj.position_id
             fields["email"] = email
             NetworkService.event("declineUserSchicht", fields)*/

        }

        $scope.declineUser = function (email, schichtObj, posObj)
        {
            $("#dialog_declineUserMemo").modal("open")

            data = {email: email,
                position_id: posObj.position_id,
                schicht_id: schichtObj.schicht_id}
            MainService.setDialogData("dialog_declineUserMemo", data)
            /*fields = {}
             fields["schicht_id"] = schichtObj.schicht_id
             fields["position_id"] = posObj.position_id
             fields["email"] = email
             NetworkService.event("declineUserSchicht", fields)*/

        }

        $scope.removeUser = function (email, schichtObj, posObj)
        {

            var schicht_id = schichtObj.schicht_id
            var position_id = posObj.position_id
            var email = email
            $rootScope.$emit("render_dialog_acceptUserDeletionCtrl", {schicht_id: schicht_id, position_id: position_id, email: email})

        }


        $scope.getInputClass = function (schichtObj, email)
        {
            var ret = ""
            var mitarbeiter = schichtObj.mitarbeiter[email]
            if (mitarbeiter == undefined)
            {
                ret = ColorService.getColor("freePositionField")
            } else
            {
                if (mitarbeiter.approved == 1)
                {
                    ret = ColorService.getColor("otherPositionFieldApproved")

                } else if (mitarbeiter.approved == 0 | mitarbeiter.approved == 2)
                {
                    ret = ColorService.getColor("otherPositionFieldNotApproved")//"yellow lighten-4"
                }

            }
            return ret;
        }

        $scope.openUser = function (schichtObj, i)
        {
            //window.location.replace("Mitarbeiter.php?maId=" + i)
            window.open("Mitarbeiter.php?maId=" + i, '_blank');

        }
        $scope.schichtPosFieldClicked = function (email, schichtObj, posObj)
        {
            $scope.posId = posObj.position_id
            $scope.schichtId = schichtObj.schicht_id
            if (!isNaN(email))
            {
                $('#modal3').modal("open");
            } else
            {
                var data = {email: email, schichtObj: schichtObj, posObj: posObj, event_id: $scope.eventId}
                MainService.setDialogData("dialog_editSchichtPositionMitarbeiter", data)
                $rootScope.$emit("render_dialog_editSchichtPositionMitarbeitCtrl")
                $("#dialog_editSchichtPositionMitarbeiter").modal("open");
            }
        }

        $scope.registerForSchicht = function (posObj, schichtObj)
        {

            if (lapsOver = $scope.CalenderAgent.doesOverlapp(schichtObj))
            {

            } else
            {
                //alert(schichtId+" "+posId)
                $scope.schichtId = schichtObj.schicht_id;
                $scope.posId = posObj.position_id;
                $("#registerForSchichtWindow").fadeIn();
                $("#overlayWindow").fadeIn();
            }

            //console.log(posId)
        }

        $scope.calendarWidth = 3

        $scope.filterCalendarPage = function (data, start)
        {
            var size = $scope.calendarWidth + start;
            var newCalendar = {}
            var ind = 0
            if (data != undefined)
            {
                Object.keys(data).forEach(function (el) {

                    if (ind >= size | ind < start)
                    {
                    } else
                    {
                        newCalendar[el] = data[el]
                    }
                    ind++;
                })
            }
            return newCalendar
        }

        $scope.getIfActiveTabClass = function (i)
        {
            var ret = "";
            if (i == 0)
            {
                ret = "active"
            }
            return ret;
        }



        $scope.loadCalendarPage = function (page)
        {
            $(".topTabs").removeClass("active")
            $("#paginatorId" + page).toggleClass("active")

            page = page * $scope.calendarWidth
            var filteredData = $scope.filterCalendarPage($scope.wholeCalendar, page)
            $scope.positionen = filteredData
        }

        $scope.getStatisics = function ()
        {
            fields = {}
            fields["command"] = "getStatistics"
            fields["event_id"] = $scope.eventId
            var req = {
                method: 'POST',
                url: "Api/hosiapi.php",
                data: $.param(fields),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            }
            $http(req).then(function (data) {
                statistic = data.data

                statisticsService.setCount(statistic.mitarbeiter_gesamt)
                statisticsService.setFix(statistic.mitarbeiter_besetzt)
                statisticsService.setReserved(statistic.mitarbeiter_warten)
            }, "json");



        }

        $scope.paintCalendar = function ()
        {
            NetworkService.getCalendar(EventId, function (data) {
                $scope.renderCalendar(data)
            })
        }

        $scope.renderCalendar = function (data)
        {

            $scope.wholeCalendar = data["positionen"]
            $scope.getStatisics($scope.wholeCalendar)
            $scope.paginator = $scope.getPaginator(data["positionen"]);
            $scope.positionsForDropdown = data["positionen"];

            $("#positionSelect").material_select();
            filteredData = $scope.filterCalendarPage($scope.wholeCalendar, 0)
            $scope.positionen = filteredData
            $scope.CalenderAgent = new calenderChecker(data["positionen"], $scope.maId);
            len = $scope.calendarWidth//Object.keys(data.data["positionen"]).length
            ratio = 100 / len
            //console.log(data["positionen"])
            Object.keys(data["positionen"]).forEach(function (el) {
                //console.log(data.data["position"][el]["schichten"][0])

                firstKey = Object.keys(date = data["positionen"][el]["schichten"])[0]
                date = data["positionen"][el]["schichten"][firstKey]["start"]

                if ($scope.startDate == -1)
                {
                    $scope.startDate = date;
                }

                if ($scope.startDate > date)
                {
                    $scope.startDate = date;
                }
            })

            $("head").append('<style type="text/css"></style>');
            var newStyleElement = $("head").children(':last');
            //console.log(ratio)
            newStyleElement.html('.head{width:' + ratio + '%;}');

            $("head").append('<style type="text/css"></style>');
            var newStyleElement = $("head").children(':last');
            newStyleElement.html('.calendarCol{width:' + ratio + '%;}');
            //(".head").css("width", ratio + "%")
        }

        $scope.addUserIntoInput = function (email)
        {
            $scope.searchModel = email
        }

        $scope.rightNextPaginator = function ()
        {
            var length = Object.keys($scope.wholeCalendar).length
            if (length > (($scope.paginatorPage + 1) * 9))
            {
                $scope.paginatorPage++;
                $scope.paginator = $scope.getPaginator($scope.wholeCalendar);
            }
        }



        $scope.leftNextPaginator = function ()
        {
            if ($scope.paginatorPage > 0)
            {
                $scope.paginatorPage--;
                $scope.paginator = $scope.getPaginator($scope.wholeCalendar);
            }

        }

        $scope.getPaginator = function (calendar)
        {
            var item = calendar
            var ret = []
            var lastThree = ""
            var ind = 1;
            var buttonId = 0
            var keys = Object.keys(item)
            var keyind = 9 * $scope.paginatorPage
            var lastButtonNotRenderd = false;

            if (item != undefined)
            {
                while (keyind < (keys.length) && buttonId < 3)
                {
                    var el = keys[keyind];
                    if (ind % 3 == 0)
                    {
                        lastThree += item[el].position_text + ""
                        ret.push({name: lastThree, id: buttonId + ($scope.paginatorPage * 3)})
                        lastThree = ""
                        lastButtonNotRenderd = false
                        buttonId++;
                    } else
                    {
                        lastThree += item[el].position_text + " | "
                        lastButtonNotRenderd = true
                    }

                    ind++;
                    keyind++;
                }

            }
            if (lastButtonNotRenderd)
            {
                ret.push({name: lastThree, id: buttonId + ($scope.paginatorPage * 3)})
            }

            return ret;
        }
        $scope.error = function (msg) {
            Notification.error(msg);
        };

        $scope.error = function (msg) {
            Notification.error(msg);
        };

        $scope.success = function (msg) {
            Notification.success(msg);
        };

        $scope.addUserToSchicht = function ()
        {
            email = $scope.searchModel
            schichtId = $scope.schichtId;
            posId = $scope.posId;

            fields = {}
            fields["command"] = "addUserToSchichtFromAdmin"
            fields["schichtId"] = schichtId
            fields["eingesetzt_als"] = $scope.eingesetztAlsModel;
            fields["posId"] = posId
            fields["email"] = email
            var req = {
                method: 'POST',
                url: "Api/hosiapi.php",
                data: $.param(fields),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            }
            $http(req).then(function (data) {
                console.log(data)
                if (data.data.done.error != "0")
                {
                    if (data.data.done.error == "11")
                    {
                        $scope.error("User ist schon eingetragen, vielleicht wurde er blockiert")

                    }
                } else
                {
                    $scope.success("User wurde hinzugefügt")
                }
                $scope.paintCalendar()
            }, "json");



        }

        $scope.paintCalendar()
    }]);
